import { ReactElement, useState } from 'react'
import { observer } from 'mobx-react-lite'
import { useSearchStore } from 'src/store/search/SearchStore'
import { Thumbnail } from 'src/ui-components'
import { Slide } from 'src/store/models/SearchModels'
import styled from 'styled-components'
import { breakpoints } from '../../../../../../../src/theme/breakpoints'
import GenericCarousel from '../../../../../../../src/ui-components/carousels/GenericCarousel'
import image360Icon from '/assets/preview-360-image.svg'
import { IMAGE_360_SLIDE } from './Contstants'
interface Props {
  slides: Array<Slide>
  onHover: (slide: Slide) => void
  show360Slide: boolean
}

const insert360Slide = (slides: Slide[]): Slide[] => {
  if (slides.length === 1) return [...slides, IMAGE_360_SLIDE]

  return slides.map((s, idx) => (idx === 1 ? [IMAGE_360_SLIDE, s] : s)).flat()
}

const Carousel = observer(
  ({ slides, onHover, show360Slide }: Props): ReactElement => {
    const { partDetailsLoading } = useSearchStore()
    const [selectedSlide, setSelectedSlide] = useState<Slide>(slides[0])

    const handleSelect = (slide: Slide) => {
      setSelectedSlide(slide)
      onHover(slide)
    }

    const allSlides = show360Slide ? insert360Slide(slides) : slides

    return (
      <GenericCarousel
        items={allSlides}
        itemsPerView={4}
        loading={partDetailsLoading}
        renderItem={(slide) =>
          slide.alt === '360-image' ? (
            <Image360IconWrapper selected={slide.id === selectedSlide.id}>
              <Image360Slide src={allSlides[0].src} />
              <Image360SlideCover
                src={image360Icon}
                alt="360 view"
                onMouseEnter={() => handleSelect(slide)}
                style={{ width: '100%' }}
              />
            </Image360IconWrapper>
          ) : (
            <Slider
              key={slide.id}
              onMouseEnter={() => handleSelect(slide)}
              selected={slide.id === selectedSlide.id}
            >
              <Thumbnail urlOrBase64={slide.src} width={49} height={57} />
            </Slider>
          )
        }
      />
    )
  }
)

// Styled components
interface SliderProps {
  selected: boolean
}

const Slider = styled.div<SliderProps>`
  width: 76px;
  height: 76px;
  border: ${({ selected }) =>
    selected ? '1px solid #050505' : '1px solid #d3d2cf'};
  cursor: pointer;
  width: 76.17px;
  height: 76.17px;
  display: flex;
  align-items: center;
  justify-content: center;
  @media screen and (max-width: ${breakpoints.mobileLarge}px) {
    width: 60.17px;
    height: 60.17px;
  }
`

const Image360Slide = styled.img`
  position: absolute;
  max-width: 49px;
  max-height: 57px;
  background-color: rgba(0, 0, 0, 0.5);
  @media screen and (max-width: ${breakpoints.mobileLarge}px) {
    width: 61px;
  }
`

const Image360SlideCover = styled.img`
  position: absolute;
  max-width: 100%;
  max-height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  @media screen and (max-width: ${breakpoints.mobileLarge}px) {
    width: 61px;
  }
`

const Image360IconWrapper = styled.div<SliderProps>`
  position: relative;
  width: 76px;
  height: 76px;
  display: flex;
  justify-content: center;
  align-items: center;
  border: ${({ selected }) =>
    selected ? '1px solid #050505' : '1px solid #d3d2cf'};
`

export default Carousel
